import TagChevronIcon from '@duyank/icons/regular/TagChevron';
import { Checkbox, Textarea } from '@heroui/react';
import React, { ChangeEvent, FC, useRef, useState } from 'react';
import Popover from '../common/popover/Popover';
import { useEditor } from '../hooks';
import { ImpressionTag } from '../types';
import { validateImpressionTag } from '../ultils/validateImpressionTag';
import SettingButton from './SettingButton';

export { validateImpressionTag };

const ImpressionTagSettings: FC = () => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { actions, activePage, pages } = useEditor((state) => ({
    activePage: state.activePage,
    pages: state.pages,
  }));

  const currentContainer = pages[activePage].layers.ROOT;
  const impressionTag = currentContainer?.data?.props?.impressionTag

  const onChange = (name: keyof ImpressionTag, value: boolean | string) => {
    if (name === 'tagContent') {
      const strVal = value as string;
      setError(validateImpressionTag(strVal.trim()));
      actions.setImpressionTag(activePage, 'ROOT', {
        hasImpressionTag: impressionTag?.hasImpressionTag ?? false,
        tagContent: strVal,
      });
    } else {
      actions.setImpressionTag(activePage, 'ROOT', {
        hasImpressionTag: impressionTag?.hasImpressionTag ?? false,
        tagContent: impressionTag?.tagContent ?? '',
        ...({ [name]: value } as Partial<ImpressionTag>),
      });
    }
  };

  return (
    <>
      <SettingButton
        ref={buttonRef}
        css={{ fontSize: 20 }}
        isActive={impressionTag?.hasImpressionTag}
        onClick={() => setOpen(true)}
      >
        <span>
          <TagChevronIcon />
        </span>
      </SettingButton>
      <Popover
        anchorEl={buttonRef.current}
        offsets={{ 'bottom-end': { x: 0, y: 8 } }}
        open={open}
        placement={'bottom-end'}
        onClose={() => {
          setOpen(false);
          setError(null);
        }}
      >
        <div css={{ padding: 16, width: 280, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div>
            <Checkbox
              color='default'
              isSelected={impressionTag?.hasImpressionTag ?? false}
              style={{ gap: 4 }}
              onValueChange={(value) => onChange('hasImpressionTag', value)}
            >
              Activate Impression Tag
            </Checkbox>
          </div>
          {impressionTag?.hasImpressionTag && (
            <div css={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <Textarea
                errorMessage={error}
                isInvalid={!!error}
                minRows={3}
                placeholder='<IMG SRC="https://ad.doubleclick.net/..." BORDER="0" HEIGHT="1" WIDTH="1" ALT="Advertisement">'
                size='lg'
                value={impressionTag?.tagContent ?? ''}
                variant='bordered'
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  onChange('tagContent', e.target.value)
                }
              />
              <div css={{ fontSize: 11, color: 'rgba(36,49,61,0.55)', lineHeight: 1.4 }}>
                Must start with &lt;img or &lt;IMG.
              </div>
            </div>
          )}
        </div>
      </Popover>
    </>
  );
};

export default ImpressionTagSettings;
